import { NgModule } from '@angular/core';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    exports: [ToggleSwitchComponent],
    declarations: [ToggleSwitchComponent],
    providers: [],
})
export class CommonUtilityModule { }
